import type { Session } from '../../../../core/domain/Session';
import { goToImageByCumul, refreshImageLandmark, retrieveAnnotationsForCurrentImage } from '../../../../core/legacy/actions';
import { currentImageCumulQuery } from '../../../../core/streetViewer/queries';
import { currentImagePositionResolved } from '../../../../core/streetViewer/state';
import { useAppDispatch, useAppSelector } from '../../../../types';
import useQueryParams from '../../../../utils/use-query-params';

const useGoToImageByCumul = (session: Session | null): (() => void) => {
    const dispatch = useAppDispatch();
    const routeQueryParams: URLSearchParams = useQueryParams();
    const storedCurrentImageCumul = useAppSelector(currentImageCumulQuery);

    const goToCumul = (): void => {
        const cumulImageQueryParam = routeQueryParams.get('cumul');
        if (cumulImageQueryParam) {
            dispatch(goToImageByCumul(cumulImageQueryParam));

            return;
        }

        if (session && storedCurrentImageCumul && session.id === storedCurrentImageCumul.sessionId) {
            dispatch(goToImageByCumul(storedCurrentImageCumul.cumul));

            return;
        }

        // No position to correct to (fresh open, no stored/deep-linked position) -
        // the current image stays at its default, but annotations still need loading.
        dispatch(currentImagePositionResolved());
        dispatch(retrieveAnnotationsForCurrentImage());
        dispatch(refreshImageLandmark());
    };

    return goToCumul;
};

export default useGoToImageByCumul;
